export enum LeaseTypes {
  CanadaOntario = 'canada-ontario',
  CanadaQuebec = 'canada-quebec',
}
